import { jsx as _jsx } from "react/jsx-runtime";
import { Suspense } from "react";
import Spinner from "@components/Spinner/Spinner";
import Widget from "@components/Widget/Widget";
import { PunctualityReport } from "../components";
import "./PunctualityReportWidget.scss";
export const PunctualityReportWidget = () => {
    return (_jsx(Widget.Container, { children: _jsx(Suspense, { fallback: _jsx(Spinner, {}), children: _jsx(Widget.Body, { children: _jsx(PunctualityReport, {}) }) }) }));
};
PunctualityReportWidget.displayName = "PunctualityReportWidget";
